import DevicesIcon from '@mui/icons-material/Devices'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

export const routeBackOfficeCompanionAdminCommon = [
  {
    route: 'companionAdmin',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Companion',
    icon: DevicesIcon,
    href: '/backoffice/group/companion',
    menuHeader: true,
    position: 450,
  },
]
